import clsx from 'clsx';
import React from 'react';

import { preventAndThrottle } from '../../../utils';
import styles from './ConnectionAlert.module.scss';

interface IConnectionAlertProps {
  onRetry: React.MouseEventHandler;
  onBeforeRetry?: React.MouseEventHandler;
  className?: string;
}

const ConnectionAlert: React.FC<IConnectionAlertProps> = ({ className, onRetry, onBeforeRetry }) => {
  return (
    <div className={clsx(styles.container, className)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
        <path
          fill="#D9D9D9"
          fillRule="nonzero"
          d="M25.091 14.917c2.266 0 4.106 1.827 4.106 4.084a4.09 4.09 0 0 1-3.195 3.984l-.001 22.972h14.617v2h-30.25v-2h13.633V22.94a4.091 4.091 0 0 1-3.01-3.735l-.006-.204c0-2.257 1.84-4.084 4.106-4.084zm16.66-12.76c9.311 9.312 9.364 24.36.112 33.612l-1.414-1.415c8.468-8.468 8.42-22.25-.113-30.782l1.415-1.414zM8.14 2.046l1.414 1.414c-8.468 8.468-8.42 22.25.113 30.783l-1.414 1.414c-9.312-9.312-9.365-24.36-.113-33.611zm26.48 7.242c5.347 5.347 5.377 13.988.063 19.302l-1.414-1.415c4.53-4.53 4.505-11.905-.062-16.472l1.414-1.415zm-19.3-.062l1.414 1.414c-4.53 4.53-4.505 11.906.062 16.473l-1.414 1.414c-5.346-5.346-5.376-13.987-.062-19.301zm9.771 7.692a2.095 2.095 0 0 0-2.106 2.084c0 1.15.942 2.084 2.106 2.084a2.095 2.095 0 0 0 2.106-2.084c0-1.15-.941-2.084-2.106-2.084z"
        />
      </svg>

      <p className={styles.description}>
        인터넷 연결이 불안정합니다. <br />
        <span className={styles.retryCaption}>재시도해주세요.</span>
      </p>
      <button className={styles.retryButton} onClick={preventAndThrottle(onRetry, onBeforeRetry)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
          <path
            fill="#0152CC"
            fillRule="evenodd"
            d="M12.267 4.233A5.305 5.305 0 0 0 8.5 2.667 5.326 5.326 0 0 0 3.173 8 5.326 5.326 0 0 0 8.5 13.333c2.487 0 4.56-1.7 5.153-4h-1.386A3.994 3.994 0 0 1 8.5 12c-2.207 0-4-1.793-4-4s1.793-4 4-4c1.107 0 2.093.46 2.813 1.187L9.167 7.333h4.666V2.667l-1.566 1.566z"
          />
        </svg>
        &nbsp;재시도
      </button>
    </div>
  );
};

export default ConnectionAlert;
